import type { YachtViewerState } from "@cloudnest/yacht-engine";
import type { CSSProperties } from "react";

const PLAYER_COLORS = [
  "#14b8a6",
  "#f59e0b",
  "#60a5fa",
  "#f43f5e",
  "#a78bfa",
  "#22c55e",
  "#fb7185",
  "#38bdf8",
  "#f97316",
  "#84cc16",
  "#e879f9",
  "#cbd5e1",
] as const;

export function PlayerScoreRail({
  state,
  selectedPlayerId,
  onSelectPlayer,
}: {
  readonly state: YachtViewerState;
  readonly selectedPlayerId: string;
  readonly onSelectPlayer: (playerId: string) => void;
}) {
  return (
    <section className="yacht-player-rail" data-testid="yacht-player-rail">
      {state.seatingOrder.map((playerId, index) => {
        const slot = state.turnSlotsByPlayerId[playerId];
        const sheet = state.scoreSheetsByPlayerId[playerId];
        const recentlyScored = state.lastScoreResult?.playerId === playerId;
        const status =
          state.phase === "GAME_OVER"
            ? "done"
            : slot?.status === "LOCKED"
              ? "done"
              : slot?.status === "OPEN"
                ? "active"
                : recentlyScored
                  ? "done"
                  : "idle";
        const total = sheet?.total ?? 0;
        return (
          <button
            className="yacht-rail-token"
            data-selected={selectedPlayerId === playerId ? "true" : "false"}
            data-status={status}
            data-testid={`yacht-rail-player-${playerId}`}
            key={playerId}
            onClick={() => onSelectPlayer(playerId)}
            style={
              {
                "--yacht-player-color":
                  PLAYER_COLORS[index % PLAYER_COLORS.length],
              } as CSSProperties
            }
            title={`${state.players[index]?.displayName ?? playerId} ${total}`}
            type="button"
          >
            <span className="yacht-rail-ring">
              <span className="yacht-rail-index">{index + 1}</span>
            </span>
          </button>
        );
      })}
    </section>
  );
}
